import common from "@commonLang/messages";
import whatsapp from "@whatsappLang/messages";
import validationEn from "@/js/locales/en/validation";
import validationRo from "@/js/locales/ro/validation";
import webOffersRo from "@/js/locales/ro/web_offers";
import webOfferCategoriesRo from "@/js/locales/ro/web_offer_categories";
import jobPostsRo from "@/js/locales/ro/job_posts";
import jobPostCategoriesRo from "@/js/locales/ro/job_post_categories";
import userTimesheetsRo from "@/js/locales/ro/user_timesheets";
import timesheetWorkloadsRo from "@/js/locales/ro/timesheet_workloads";
import doorUserTimesheetsRo from "@/js/locales/ro/door_user_timesheets";
import webOffersEn from "@/js/locales/en/web_offers";
import jobPostsEn from "@/js/locales/en/job_posts";
import shopOrderProductsRo from "@/js/locales/ro/shop_order_products";
import shopOrdersRo from "@/js/locales/ro/shop_orders";
import reservationsEn from "@/js/locales/en/reservations";
import reservationsRo from "@/js/locales/ro/reservations";
import attachmentsRo from "@/js/locales/ro/attachments";

export default {
    en: {
        ...common.en,
        ...whatsapp.en,
        "validation": validationEn,
        "web_offers": webOffersEn,
        "job_posts": jobPostsEn,
        "reservations": reservationsEn,
    },
    ro: {
        ...common.ro,
        ...whatsapp.ro,
        "validation": validationRo,
        "web_offers": webOffersRo,
        "web_offer_categories": webOfferCategoriesRo,
        "job_posts": jobPostsRo,
        "job_post_categories": jobPostCategoriesRo,
        "user_timesheets": userTimesheetsRo,
        "timesheet_workloads": timesheetWorkloadsRo,
        "door_user_timesheets": doorUserTimesheetsRo,
        "shop_order_products": shopOrderProductsRo,
        "shop_orders": shopOrdersRo,
        "reservations": reservationsRo,
        "attachments": attachmentsRo
    }
}
